import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MessageHeartDouble = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 7.69C14.633 5.05 11.87 3 8.52 3 4.92 3 2 5.368 2 8.29c.021.745.21 1.475.552 2.131a4.76 4.76 0 0 0 1.416 1.652L4.126 15l2.476-1.653q.255.064.518.112M9.7 6c-.258 0-.509.072-.723.207-.213.134-.38.325-.477.547a1.24 1.24 0 0 0-.478-.548A1.37 1.37 0 0 0 7.298 6c-.357.029-.69.183-.93.43A1.28 1.28 0 0 0 6 7.34C6 8.806 8.167 10 8.5 10S11 8.806 11 7.339a1.28 1.28 0 0 0-.369-.909A1.46 1.46 0 0 0 9.7 6m7 6c-.258 0-.509.072-.723.207a1.23 1.23 0 0 0-.477.547 1.24 1.24 0 0 0-.478-.548 1.36 1.36 0 0 0-.724-.206 1.46 1.46 0 0 0-.93.431 1.28 1.28 0 0 0-.368.908C13 14.807 15.167 16 15.5 16s2.5-1.193 2.5-2.661a1.28 1.28 0 0 0-.369-.909A1.46 1.46 0 0 0 16.7 12m-1.2-3c3.59 0 6.5 2.368 6.5 5.29a4.9 4.9 0 0 1-.55 2.131 4.75 4.75 0 0 1-1.412 1.652L19.882 21l-2.468-1.653a8 8 0 0 1-1.913.234c-3.59 0-6.5-2.368-6.5-5.29C9 11.37 11.91 9 15.5 9"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MessageHeartDouble) as SvgIcon;
export { ForwardRef as ReactComponent };
